import { serverFetch } from "@core/server";

export function fetchSprPredList({ q, skip = 0, take = 50 } = {}) {
  return serverFetch("sprs/pred", {
    queryParams: {
      skip,
      take,
      ...(q ? { q } : {})
    }
  });
}

export function fetchSprPred(id) {
  return serverFetch(`sprs/pred/${id}`);
}

export function fetchSprPredLookups() {
  return serverFetch("sprs/pred/lookups");
}

export function createSprPred(bodyData) {
  return serverFetch("sprs/pred", {
    method: "POST",
    bodyData
  });
}

export function saveSprPred(bodyData) {
  return serverFetch("sprs/pred", {
    method: "PUT",
    bodyData
  });
}

export function deleteSprPred(id) {
  return serverFetch(`sprs/pred/${id}`, {
    method: "DELETE"
  });
}

export function matchSprPredPhones(phones, signal) {
  return serverFetch("sprs/pred/match-phones", { method: "POST", bodyData: { phones } }, signal);
}
